import 'core-js/features/array/to-reversed'
import 'core-js/features/array/to-sorted'
import 'core-js/features/array/to-spliced'
